<template>
  <div class="index-menu">
    <el-card>
      <div class="card-title">GamePlan</div>
      <div class="card-user">
        <div class="user-pic">
          <img :src="avatarUrl" />
        </div>
        <div class="user-info">
          <div class="user-name">
            <span>欢迎您</span>
            <span style="font-weight: bold;padding-left: 6px;">{{ clientName }}</span>
          </div>
          <div>
            <router-link to="/user/index" class="user-opera">管理账户信息</router-link>
          </div>
        </div>
      </div>
      <div class="index-menu">
        <el-menu router :default-active="$route.path">
        </el-menu>
      </div>
    </el-card>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { commonUtils } from '@/utils/common'
import userApi from '@/api/user'
export default {
  data () {
    return {
      clientName: '',
      collectList: [],
      allOrderAmount: 0,
      progressOrderAmount: 0,
      teamAmount: 0,
      isRTM: false
    }
  },
  computed: {
    ...mapGetters([
      'userInfo'
    ]),
    avatarUrl () {
      const defaultAvatar = require('../../../assets/images/default-avatar.png')
      return commonUtils.getImageUrl(this.userInfo.avatarImageUri, defaultAvatar)
    }
  },
  created () {
    this.init()
  },
  methods: {
    init () {
      this.clientName = this.userInfo.clientName
      this.isRTM = this.userInfo.employeeLevel === 50
      this.getMonthAmount()
      if (this.isRTM) {
        this.getTeamAmount()
      }
    },

    // 本月订单
    getMonthAmount () {
      this.$store.dispatch('getMonthAmount', { queryType: '01' }).then(res => {
        if (res.data.resultCode === '0') {
          this.collectList = res.data.resultData.tradeApplyCollectList || []
          if (this.collectList.length) {
            this.collectList.forEach(item => {
              this.allOrderAmount = this.allOrderAmount + item.finishedCount + item.inProgressCount
              this.progressOrderAmount = this.progressOrderAmount + item.inProgressCount
            })
          }
        }
      })
    },

    // 销售团队总数
    getTeamAmount () {
      userApi.queryClientList(this.queryParam).then(res => {
        if (res.data.resultCode === '0') {
          this.teamAmount = res.data.resultData.pageInfo.totalCounts
        }
      })
    }
  }

}
</script>

<style lang="scss" scoped>
.index-menu {
  ::v-deep .el-card__body {
    padding: 0;
  }

  ::v-deep .el-menu-item {
    height: 50px;
    line-height: 50px;
    color: #000;
    border-bottom: 1px solid #dee2ed;
  }
}

.el-card {
  height: 620px;
  .card-title {
    padding: 18px;
    font-size: $font-16;
  }
  .card-user {
    height: 120px;
    background-color: $base-blue;
    display: flex;
    align-items: center;
    .user-pic {
      width: 80px;
      height: 80px;
      margin-left: $content-large;
      margin-right: $content-large;
      img {
        width: 100%;
        height: 100%;
        border-radius: 50%;
      }
    }
    .user-info {
      color: $base-white;
      .user-name {
        font-size: $font-16;
        margin-bottom: 10px;
      }
      .user-opera {
        color: $base-white;
        font-size: $font-12;
      }
    }
  }
  .index-menu {
    font-size: $font-14;
    .menu-num {
      margin-top: 5px;
      position: absolute;
      right: 30px;
    }
  }
}
</style>
